import {
  getKeyFromLocalStorage,
  setKeyToLocalStorage,
} from '@quintoandar/fwp-storage';

const USER_SESSION = 'USER_SESSION';

class UserSession {
  constructor(sessionId, amplitude) {
    this.amplitude = amplitude;
    this.sessionId = sessionId;
    this.session = false;
  }

  checkFirstUser() {
    return getKeyFromLocalStorage(USER_SESSION) === null;
  }

  validateSessionId() {
    if (!this.sessionId) return false;

    return getKeyFromLocalStorage(USER_SESSION) === this.sessionId.toString();
  }

  hydrateSessionId() {
    setKeyToLocalStorage(USER_SESSION, this.sessionId);
  }

  sendInfoToAmplitude(payload) {
    if (!this.session) {
      this.amplitude.setUserProperties(payload);
      this.session = true;
    }
  }

  refreshUserSession() {
    this.session = false;
  }

  getCurrentUserSessionStatus() {
    return this.session;
  }
}

export { USER_SESSION };
export default UserSession;
